import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Loading from '../Loading/Loading';

const ModalBody = ({ children, className, id, isLoading, ...rest }) => {
  const classes = cn(
    'c-modal__content',
    {
      'is-loading': isLoading,
    },
    className
  );
  return (
    <div className={classes} id={id} {...rest}>
      {isLoading ? <Loading size="large" /> : children}
    </div>
  );
};

ModalBody.part = 'modal-body';

export default ModalBody;

ModalBody.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
};

ModalBody.defaultProps = {
  children: null,
  className: '',
  isLoading: false,
};
